<template>
  <div class="control_wrapper">
    <ejs-treeview id="treeview" :fields="fields" :node-clicked="nodeClicked" />
  </div>
</template>
<script>
import Vue from 'vue';
import { TreeViewPlugin } from '@syncfusion/ej2-vue-navigations';

Vue.use(TreeViewPlugin);

export default Vue.extend({
    name: 'MobileTree',
    data() {
        return {

        };
    },
    methods: {
        nodeClicked(e) {
            // we may add this back in
            // const personId = e.node.dataset.uid;
            // console.log(personId);

            // if (personId > 0) {
            //     this.$router.push(`/people/${personId}`);
            // }
        },
    },
    props: {
        tree: null
    },
    computed: {
        fields() {
            return {
                dataSource: this.tree,
                id: 'nodeId',
                text: 'nodeText',
                child: 'nodeChild'
            };
        }
    },
});
</script>
